import React from 'react';
import WaitlistHeader from './WaitlistHeader';

/**
 * MarketingShell — shared dark atmospheric layout for all public marketing pages.
 * Identical background treatment to WhitepaperPage & ManifestoPage.
 * Use this to wrap Trust Center, Privacy, Terms, Pricing, Brain Comparison, etc.
 */
const NOISE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PC9maWx0ZXI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbHRlcj0idXJsKCNhKSIgb3BhY2l0eT0iMSIvPjwvc3ZnPg==';

const MarketingShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="min-h-screen flex flex-col overflow-x-hidden relative bg-hig-bg-primary">
        {/* Background — identical to MarketingSite, dark + light aware */}
        <div className="fixed inset-0 z-0 overflow-hidden bg-hig-bg-primary">
            <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 dark:opacity-100 opacity-0" />
            <div className="absolute inset-0 bg-gradient-to-br from-stone-50 via-amber-50/30 to-stone-100 dark:opacity-0 opacity-100" />
            <div className="absolute inset-0 opacity-[0.015]" style={{ backgroundImage: `url("${NOISE}")` }} />
        </div>
        <WaitlistHeader />
        <main className="relative z-10 pt-16 flex-1">
            {children}
        </main>
    </div>
);

export default MarketingShell;
